<template>
  <div class="entry-projects-group">
    <div
      class="entry-projects-group__heading"
      @click="toggleState"
      :class="{ 'is-archive': isArchive }"
      v-if="heading"
    >
      {{ heading }}
      <button v-if="!isArchive" @click="$root.$emit('create-project')">
        <ui-icon name="plus" />
      </button>
      <ui-icon
        v-if="isArchive"
        :name="isShowArchive ? 'arrow-down' : 'arrow-right'"
      />
    </div>
    <transition-group
      name="list-complete"
      tag="div"
      class="entry-projects-group"
      v-if="isShowArchive || !isArchive"
    >
      <template v-for="project in projects">
        <div
          class="entry-projects-group__item"
          :class="{ 'is-active': project.id === currentProject.id }"
          :key="project.id"
        >
          <entry-project :project="project" />
        </div>
        <div
          class="entry-projects-group__item"
          :class="{ 'is-active': project.id === currentProject.id }"
          v-if="project.id === currentProject.id && project.id !== 'all'"
          :key="project.id + '_endpoints'"
        >
          <div class="entry-projects-group__item-heading">
            <span>Forms:</span>
            <button
              v-if="!isArchive"
              @click="
                $root.$emit('create-form', {
                  projectName: project.name,
                  project: project
                })
              "
            >
              <ui-icon name="plus" />
            </button>
          </div>
          <entry-form :key="project.id + '_all'" :form="rootForm(project)" />
          <entry-form
            v-for="form in project.endpoints"
            :key="project.id + '_' + form.id"
            :form="form"
          />
        </div>
      </template>
    </transition-group>
  </div>
</template>

<script>
import UiIcon from '../ui-kit/ui-icon.vue'
import EntryForm from './entry-form.vue'
import EntryProject from './entry-project.vue'
export default {
  name: 'entry-projects-group',
  components: {
    EntryForm,
    EntryProject,
    UiIcon
  },
  props: {
    heading: { type: String, required: false },
    projects: Array,
    currentProject: Object,
    isArchive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isShowArchive() {
      return this.$store.getters.isShowArchive
    }
  },
  methods: {
    rootForm(project) {
      const read_count = project.endpoints.reduce((count, form) => {
        return count + form.submissions_count
      }, 0)
      const full_count = project.endpoints.reduce((count, form) => {
        return count + form.submissions_full_count
      }, 0)
      return {
        id: 'all',
        form_name: 'All',
        submissions_count: read_count,
        submissions_full_count: full_count
      }
    },
    toggleState() {
      if (this.isArchive) {
        this.$store.commit('setArchiveShow', !this.isShowArchive)
      }
    }
  }
}
</script>

<style lang="scss">
.entry-projects-group {
  position: relative;
  &__heading {
    position: sticky;
    top: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5em;
    padding: 0.5rem 0.75rem 0.5rem 1rem;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    background: lighten($gray-900, 10);
    button {
      padding: 4px;
      color: inherit;
      font-size: 20px;
      background-color: transparent;
      border: 0;
      border-radius: $border-radius-sm;
      cursor: pointer;
      transition: 0.2s;
      &:hover {
        background-color: rgba($white, 0.1);
      }
      .ui-icon {
        display: block;
        svg {
          display: block;
        }
      }
    }
    &.is-archive {
      cursor: pointer;
    }
  }

  &__item {
    width: 100%;
    background-color: $gray-900;
    transition: transform 0.2s;
    &.is-active {
      background-color: rgba($white, 0.075);
    }
    &-heading {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.5rem 0.75rem 0.25rem;
      font-weight: 600;
      font-size: 12px;
      text-transform: uppercase;
      border-bottom: 1px solid rgba($white, 0.1);
      button {
        padding: 4px;
        color: inherit;
        font-size: 20px;
        background-color: transparent;
        border: 0;
        border-radius: $border-radius-sm;
        cursor: pointer;
        transition: 0.2s;
        &:hover {
          background-color: rgba($white, 0.1);
        }
        .ui-icon {
          display: block;
          svg {
            display: block;
          }
        }
      }
    }
    &:last-child {
      margin-bottom: 0.5rem;
    }
  }
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
}
.list-complete-leave-active {
  position: absolute;
  left: -9999px;
}
</style>
